export default __webpack_public_path__ + "assets/images/613d3d49cb1d2a1b4b8315aaecaf9fbb.svg";